import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SaleSummaryDto } from "../../shared/dtos/sale/SaleSummaryDto";
import { SaleResponseDto } from "../../shared/dtos/sale/SaleResponseDto";
import { PaginationDto } from "../../shared/dtos/common/PaginationDto";

export interface SaleState {
  sales: SaleSummaryDto[];
  sale: SaleResponseDto | null;
  pagination: Partial<PaginationDto>;

  loadingFetchAll: boolean;
  loadingFetchOne: boolean;

  errorFetchAll: string | null;
  errorFetchOne: string | null;
}

const initialState: SaleState = {
  sales: [],
  sale: null,
  pagination: {},

  loadingFetchAll: false,
  loadingFetchOne: false,

  errorFetchAll: null,
  errorFetchOne: null,
};

const saleSlice = createSlice({
  name: "sale",
  initialState,
  reducers: {
    setLoadingFetchAll(state) {
      state.loadingFetchAll = true;
      state.errorFetchAll = null;
    },

    setLoadingFetchOne(state) {
      state.loadingFetchOne = true;
      state.errorFetchOne = null;
    },

    setErrorFetchAll(state, action: PayloadAction<string | null>) {
      state.loadingFetchAll = false;
      state.errorFetchAll = action.payload;
    },

    setErrorFetchOne(state, action: PayloadAction<string | null>) {
      state.loadingFetchOne = false;
      state.errorFetchOne = action.payload;
    },

    setSales(state, action: PayloadAction<SaleSummaryDto[]>) {
      state.loadingFetchAll = false;
      state.sales = action.payload;
    },

    setSale(state, action: PayloadAction<SaleResponseDto | null>) {
      state.loadingFetchOne = false;
      state.sale = action.payload;
    },

    setPagination(state, action: PayloadAction<Partial<PaginationDto>>) {
      state.pagination = action.payload;
    },
  },
});

export const saleActions = saleSlice.actions;

export default saleSlice.reducer;
